export default "__VITE_ASSET__49pLxEjV__"